import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function PricingCard() {
  return <section id="offer" className="border-y-2 border-brand-orange/40 bg-brand-light px-4 py-6" data-id="element-105" data-mp="1m3rnn16tzpfw">
      <div className="mx-auto max-w-2xl" data-id="element-106" data-mp="1i37ppvefohsp">
        <div className="mb-3 text-center" data-id="element-107" data-mp="1i4ak4dayt2dd">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-108" data-mp="2esp3yyrhfc60">
            Special Launch Offer
          </p>
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-109" data-mp="29vyoodni4kln">
            SMART HOME INSTALLER PRO™
          </h2>
          <p className="mb-2 font-display text-sm font-semibold text-brand-ink sm:text-base" data-id="element-110" data-mp="210irbmnjfnbb">
            Complete 6-in-1 Installation &amp; Business System
          </p>
          <a href={CHECKOUT_URL} className="block cursor-pointer" aria-label="Buy Smart Home Installer Pro" data-id="element-111" data-mp="2sszwe68fwyta">
            <img src={PRODUCT_IMG} alt="Smart Home Installer Pro 6-in-1 system box set" className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.02] sm:max-w-[260px]" data-id="element-112" data-mp="32jssrk2edryw" />
          </a>
        </div>

        <div className="mb-3 rounded-2xl border-4 border-brand-orange bg-white p-4 text-center shadow-2xl sm:p-5" data-id="element-113" data-mp="2xski6kpc00k5">
          <ul className="mb-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-sm font-semibold text-brand-ink" data-id="element-114" data-mp="2js9ozb0ju9vt">
            <li data-id="element-115" data-mp="2oqkzlnyo4of3">✅ 6 Professional Modules</li>
            <li data-id="element-116" data-mp="29wq6prewr9pj">✅ 5 Premium Bonuses</li>
          </ul>
          <p className="mb-1 text-sm font-medium text-brand-muted" data-id="element-117" data-mp="29y1ahr8cshgn">
            Regular Price: <span className="line-through" data-id="element-118" data-mp="2ewubwlad8i0g">$97</span>
          </p>
          <p className="font-display text-sm font-extrabold uppercase tracking-wide text-brand-orange sm:text-lg" data-id="element-119" data-mp="85czuwtdqrqu">
            🔥 TODAY ONLY: $27 USD
          </p>
          <p className="mb-3 text-xs font-medium text-brand-muted" data-id="element-120" data-mp="bly3ir8gxzn5">
            Secure payment in your local currency.
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-121" data-mp="6m39ietectxv">🚀 YES! I WANT MY COMPLETE SYSTEM</CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-122" data-mp="1p384h7hsfd3">
          <div className="flex items-center gap-1" data-id="element-123" data-mp="3ttxcegwyrujx">
            <StarIcon className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-124" data-mp="ubnv75gxq5au" />
            <span data-id="element-125" data-mp="pd4831qlungw">⭐⭐⭐⭐⭐ 4.9/5 — Verified Student Reviews</span>
          </div>
          <span className="hidden text-brand-line sm:inline" data-id="element-126" data-mp="pfyv91106me0">•</span>
          <div className="flex items-center gap-1" data-id="element-127" data-mp="klco5a1yffzq">
            <ShieldCheckIcon className="h-4 w-4 text-brand-orange" data-id="element-128" data-mp="glu6qo9cdn1n" />
            <span data-id="element-129" data-mp="gjhqqgn59mr8">🛡️ 7-Day Money-Back Guarantee</span>
          </div>
        </div>
      </div>
    </section>;
}